export default __webpack_public_path__ + "static/media/final-score.ab4faf16.svg";